/**
 * Same rules as covecms `src/lib/map-image-zoom.ts` (keep in sync when changing).
 * Includes resolveImageMapMaxZoom, resolveImageMapMinZoom, resolveImageMapLocationMenuZoom for tour overrides.
 */
export const IMAGE_MAP_MIN_ZOOM_FOR_CONSTRUCTOR = -20;
export const IMAGE_MAP_ZOOM_SNAP = 0.25;
export const IMAGE_MAP_ZOOM_DELTA = 0.25;

/** @param {number} fitZoom @param {number} [extraZoomOutSteps=1] */
export function getImageMapMinZoomAfterFit(fitZoom, extraZoomOutSteps = 1) {
  return fitZoom - extraZoomOutSteps;
}

export function getImageMapMaxZoom(width, height) {
  const w = width > 0 ? width : 0;
  const h = height > 0 ? height : 0;
  if (w === 0 && h === 0) {
    return 18;
  }
  const maxDim = Math.max(w, h, 1);
  const z = Math.ceil(Math.log2(maxDim)) + 1;
  return Math.min(22, Math.max(4, z));
}

/** @param {number} computedMax @param {number | null | undefined} userMax */
export function resolveImageMapMaxZoom(computedMax, userMax) {
  if (userMax == null || Number.isNaN(Number(userMax))) {
    return computedMax;
  }
  return Math.min(22, Math.max(-20, Number(userMax)));
}

/** @param {number} computedMin @param {number | null | undefined} userMin @param {number} maxZoom */
export function resolveImageMapMinZoom(computedMin, userMin, maxZoom) {
  const base =
    userMin != null && !Number.isNaN(Number(userMin)) ? Number(userMin) : computedMin;
  const cap = maxZoom - 1e-6;
  return Math.min(base, cap);
}

/** @param {number} minZoom @param {number} maxZoom @param {number | null | undefined} userZoom */
export function resolveImageMapLocationMenuZoom(minZoom, maxZoom, userZoom) {
  if (userZoom != null && !Number.isNaN(Number(userZoom))) {
    return Math.min(maxZoom, Math.max(minZoom, Number(userZoom)));
  }
  const desired = maxZoom - 2;
  return Math.min(maxZoom, Math.max(minZoom, desired));
}
